import { useState } from 'react'
import {
  Button,
  Checkbox,
  Divider,
  Flex,
  Modal,
  Popconfirm,
  Typography,
} from 'antd'
import { Gateway } from 'src/pages/gateway/edit/types'
import { removeNoticeFx } from 'src/pages/gateway/edit/model'
import { useUnit } from 'effector-react'

type Props = {
  gateway: Gateway
  onClose: () => void
}

export const RemoveNoticeModal = ({ gateway, onClose }: Props) => {
  const [sendEmail, setSendEmail] = useState(false)
  const { Text } = Typography

  const loading = useUnit(removeNoticeFx.pending)

  const handleSubmit = async () => {
    try {
      await removeNoticeFx({
        url: `/gateway/${gateway.gatewayId}/disable-client-notification`,
        body: { sendEmail },
      })
      onClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          Remove Gateway{' '}
          <strong style={{ color: 'var(--color-primary)' }}>
            {gateway.internalName}
          </strong>{' '}
          Notification
        </Text>
      }
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={Boolean(gateway)}
      onCancel={onClose}
      footer={null}
    >
      <Divider />
      <Checkbox
        checked={sendEmail}
        onChange={(e) => setSendEmail(e.target.checked)}
        style={{ fontSize: 16, marginBottom: 16 }}
      >
        Send a recovery email to customers?
      </Checkbox>
      <Flex gap={8} justify="flex-end">
        <Button onClick={onClose}>Cancel</Button>
        {sendEmail ? (
          <Popconfirm
            title="Remove Notice"
            description="Do you want to send a recovery email to all customers?"
            okText="Yes"
            cancelText="No"
            onConfirm={handleSubmit}
          >
            <Button type="primary" loading={loading} disabled={loading}>
              Remove Notice
            </Button>
          </Popconfirm>
        ) : (
          <Button
            type="primary"
            loading={loading}
            disabled={loading}
            onClick={handleSubmit}
          >
            Remove Notice without recovery email
          </Button>
        )}
      </Flex>
    </Modal>
  )
}
